import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Label } from 'reactstrap';

/**
 * Сomponent to select the position of the component on the page
 * @param {object} props - component props
 * @param {number} props.maxLength - maximum position value
 * @returns {React.Component} component position input
 */
const ComponentPositionInput = ({ maxLength }) => {
  const [value, setValue] = useState(maxLength);
  return (
    <div className="d-flex my-4">
      <Label className="font-weight-bold" htmlFor={ComponentPositionInput.name}>
        Select component position:
      </Label>
      <Input
        id={ComponentPositionInput.name}
        className="ml-2 w-25"
        bsSize="sm"
        onChange={({ target }) => {
          const { value } = target;
          setValue(value);
          window.sessionStorage.setItem('componentPosition', value);
        }}
        type="select"
        value={value}
      >
        {Array.from({ length: maxLength + 1 }).map((_, i) => (
          <option value={i}>{i + 1}</option>
        ))}
      </Input>
    </div>
  );
};

ComponentPositionInput.propTypes = {
  maxLength: PropTypes.number
};
ComponentPositionInput.defaultProps = {
  maxLength: 0
};

export default ComponentPositionInput;
